import React, { useState } from "react";
import Tabs from "./Tabs";
import Content from "./Content";

const MainPackageTab = () => {
  const [activeTab, setActiveTab] = useState("Overview");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="tour-page-tabing">
      <Tabs activeTab={activeTab} handleTabClick={handleTabClick} />
      <Content activeTab={activeTab} />
    </div>
  );
};

export default MainPackageTab;
